
export const TAB_KEY = "partnerContacts";
export const shimmerColor = "rgb(222, 236, 249)";
export const bgColor = "#e6faff";
export const customerInfoDetailsColor = "#1a1b19";
export const commonColor: string = "hsl(206, 100%, 42%)";
// Partner profile pageConstants
export const commandButtonBorderColor = "#0f6cbd";
export const commandButtonColor: string = "rgb(26, 27, 25)";